import React from 'react';
import { Box, MenuItem} from '@mui/material';

export default function ContextMenuItem({label, onClick, disabled = false}) {
  return <Box>
        <MenuItem onClick={onClick} disabled={disabled}>{label}</MenuItem>
    </Box>
};